/**
 * lh-scroll-restore.js
 * Saves scroll position + clicked product handle + grid HTML when leaving a
 * collection page, then restores it on back-navigation so Load More batches
 * survive the browser Back button.
 *
 * Works with: lh-main-collection-product-grid.liquid
 * Product wrappers: .lh-rv-product-wrapper[data-product-handle] (display:contents)
 * Product cards:    .product-item (scroll-reveal starts at opacity:0)
 *
 * Cache TTL: 30 minutes. Stale or mismatched-URL entries fall back to
 * server render silently. Different filter/sort params = different URL key =
 * separate cache entry (no explicit invalidation needed for filter changes).
 *
 * Timing note: this script is loaded via Shopify's script_tag filter (synchronous,
 * non-deferred). It executes during HTML parsing, before DOMContentLoaded and
 * before Ajaxinate initialises — so the restored HTML is in place when
 * Ajaxinate binds its container/pagination selectors.
 */
(function () {
  var KEY = 'lh_coll_scroll';
  var CACHE_TTL = 30 * 60 * 1000; // 30 minutes

  function pageKey() {
    return location.pathname + location.search;
  }

  function isBackNavigation() {
    try {
      var entries = performance.getEntriesByType('navigation');
      if (entries.length) return entries[0].type === 'back_forward';
    } catch (e) {}
    try {
      if (performance.navigation) return performance.navigation.type === 2;
    } catch (e) {}
    return false;
  }

  function cameFromProduct() {
    try {
      return !!(document.referrer && document.referrer.indexOf('/products/') !== -1);
    } catch (e) {
      return false;
    }
  }

  // ── RESTORE ──────────────────────────────────────────────────────────────────
  function tryRestore() {
    try {
      var raw = sessionStorage.getItem(KEY);
      if (!raw) return;
      var data = JSON.parse(raw);

      // Only restore for the exact collection URL we saved from
      if (data.url !== pageKey()) return;

      // Only restore on back/forward navigation or when referrer is a product page
      if (!isBackNavigation() && !cameFromProduct()) return;

      // Drop stale cache
      if (data.timestamp && Date.now() - data.timestamp > CACHE_TTL) {
        sessionStorage.removeItem(KEY);
        return;
      }

      // Prevent the browser from fighting us on scroll position
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

      // Restore the full grid HTML (all Load More batches) before Ajaxinate
      // initialises so it binds to the complete, restored container.
      if (data.html) {
        var partial = document.querySelector('[data-partial]');
        if (partial) {
          partial.innerHTML = data.html;
          // Strip stale hover state: if the user had moused over a card before
          // navigating, AnimateProductItem would have left imageTwo with class
          // "active" (opacity:1 + white background-color). On restore that
          // covers imageOne and shows as a blank card until the next mouseleave.
          partial.querySelectorAll('.product-item__image--two.active').forEach(function (el) {
            el.classList.remove('active');
          });
        }
      }

      var handle  = data.handle;
      var targetY = data.y;

      function findProductItem(h) {
        // The wrapper uses display:contents so has no box — scroll to the
        // .product-item child inside it.
        var wrapper = h && document.querySelector('[data-product-handle="' + h + '"]');
        if (wrapper) return wrapper.querySelector('.product-item') || wrapper;
        return null;
      }

      function revealImmediately(el) {
        // Skip scroll-reveal animation on the target card and all its siblings
        // so they're visible instantly on restore.
        if (!el) return;
        el.style.transition = 'none';
        el.classList.add('lh-revealed');
        var siblings = el.closest('.collection__products');
        if (siblings) {
          siblings.querySelectorAll('.product-item:not(.lh-revealed)').forEach(function (item) {
            item.style.transition = 'none';
            item.classList.add('lh-revealed');
          });
        }
      }

      function scrollToTarget() {
        var el = findProductItem(handle);
        if (el) {
          revealImmediately(el);
          el.scrollIntoView({ block: 'center' });
          return true;
        }
        // Fallback: pixel-based scroll (handle not found in DOM)
        window.scrollTo({ top: targetY });
        return false;
      }

      // Attempt 1: immediate (before first paint)
      scrollToTarget();

      // Attempt 2: after first paint (DOM fully laid out)
      requestAnimationFrame(function () {
        scrollToTarget();

        // Attempt 3: after lazy images start loading (covers CLS shifts)
        setTimeout(function () {
          scrollToTarget();
        }, 350);
      });

    } catch (e) {}
  }

  // ── SAVE ─────────────────────────────────────────────────────────────────────
  function setupSave() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a');
      if (!link || !link.href) return;

      // Only care about product detail links
      if (link.href.indexOf('/products/') === -1) return;

      var wrapper = e.target.closest('[data-product-handle]');
      var handle  = wrapper ? wrapper.getAttribute('data-product-handle') : null;

      try {
        var partial = document.querySelector('[data-partial]');
        sessionStorage.setItem(KEY, JSON.stringify({
          url:       pageKey(),
          y:         window.scrollY || window.pageYOffset,
          handle:    handle,
          html:      partial ? partial.innerHTML : null,
          timestamp: Date.now()
        }));
      } catch (ex) {}
    }, true /* capture phase — fires before any stopPropagation */);
  }

  // ── INIT ─────────────────────────────────────────────────────────────────────
  var onCollectionPage = !!document.querySelector('[data-section-type="collection"]');

  if (onCollectionPage) {
    tryRestore();
    setupSave();
  }
})();
